export type TagColor = {
  id: string;
  dot: string;
  bg: string;
  text: string;
};

export const TAG_COLORS: TagColor[] = [
  { id: "blue", dot: "#3b82f6", bg: "#dbeafe", text: "#1e40af" },
  { id: "sky", dot: "#0ea5e9", bg: "#e0f2fe", text: "#075985" },
  { id: "cyan", dot: "#06b6d4", bg: "#cffafe", text: "#155e75" },
  { id: "teal", dot: "#14b8a6", bg: "#ccfbf1", text: "#115e59" },
  { id: "emerald", dot: "#10b981", bg: "#d1fae5", text: "#065f46" },
  { id: "green", dot: "#22c55e", bg: "#dcfce7", text: "#166534" },
  { id: "lime", dot: "#84cc16", bg: "#ecfccb", text: "#3f6212" },
  { id: "yellow", dot: "#eab308", bg: "#fef9c3", text: "#854d0e" },
  { id: "amber", dot: "#f59e0b", bg: "#fef3c7", text: "#92400e" },
  { id: "orange", dot: "#f97316", bg: "#ffedd5", text: "#9a3412" },
  { id: "violet", dot: "#8b5cf6", bg: "#ede9fe", text: "#5b21b6" },
  { id: "purple", dot: "#a855f7", bg: "#f3e8ff", text: "#6b21a8" },
  { id: "fuchsia", dot: "#d946ef", bg: "#fae8ff", text: "#86198f" },
  { id: "pink", dot: "#ec4899", bg: "#fce7f3", text: "#9d174d" },
  { id: "rose", dot: "#f43f5e", bg: "#ffe4e6", text: "#9f1239" },
  { id: "red", dot: "#ef4444", bg: "#fee2e2", text: "#991b1b" },
  { id: "burgundy", dot: "#9b1c31", bg: "#f5d5d9", text: "#4a0e18" },
  { id: "brown", dot: "#92552d", bg: "#f0e1d1", text: "#3e2412" },
  { id: "brown_gray", dot: "#6b5e52", bg: "#e8e2db", text: "#2e2822" },
  { id: "dark_gray", dot: "#4b5563", bg: "#d1d5db", text: "#111827" },
];

const DEFAULT_TAG_COLOR = TAG_COLORS[0]; // blue

// Stride used to walk the palette when picking a color for a new tag. Chosen
// to be coprime with TAG_COLORS.length (20) so every color is visited once
// per full cycle, while being large enough that consecutive picks are far
// apart in hue.
const AUTO_PICK_STRIDE = 7;

export function getTagColor(colorId: string | undefined): TagColor {
  return TAG_COLORS.find((c) => c.id === colorId) ?? DEFAULT_TAG_COLOR;
}

export function pickNextTagColorId(existingCount: number): string {
  const index = (existingCount * AUTO_PICK_STRIDE) % TAG_COLORS.length;
  return TAG_COLORS[index].id;
}
